import { FeatureFlag } from '@/types/featureFlag';
import { useFeatureFlagEnabledQuery } from '@/utils/useFeatureFlagEnabled';

import { isReassignableVisit } from './v3/isReassignableVisit';

// Whether the user can complete a v3 reassign of a visit.
// The v3 flow submits status=unscheduled + outcome=none + the clinician through `/visit/edit`,
// so the backend requires assign + editState + editOutcome.
export const canReassignVisitV3 = isReassignableVisit;

// Legacy reassign goes through the route-optimizer `finalizeRoutes` mutation, gated by the
// org-level `ROUTE_OPTIMIZER_EDIT`, not a per-visit permission.

// The reassignability check for the active reassign flow, or `null` for legacy.
export const useReassignVisitPermissions = () => {
    const { enabled: hasV3, loading } = useFeatureFlagEnabledQuery(
        FeatureFlag.DASHBOARD_VISIT_REASSIGNMENT_FLOW,
    );

    return {
        filter: hasV3 ? canReassignVisitV3 : null,
        // The filter is null until the flag has loaded, so a caller that must not mistake
        // that for "no reassign" waits on this.
        loading,
    };
};

export const useReassignVisitPermissionsFilter = () => useReassignVisitPermissions().filter;
